/**
 * SitePanelContext — 현장 패널 접기/펼치기 상태 (플랫폼 apps/shell-web 동일 구조)
 */
import { createContext, useContext, useState, type ReactNode } from 'react';

interface SitePanelCtx {
  isOpen: boolean;
  /** 다음 패널 오픈 시 미리 선택할 상태 칩 코드 (''=전체). '진행 중인 현장' 진입 등에서 지정. */
  initialStatus: string;
  toggle: () => void;
  open: (status?: string) => void;
  close: () => void;
}

const SitePanelContext = createContext<SitePanelCtx | null>(null);

export function SitePanelProvider({
  children,
  defaultOpen = true,
}: {
  children: ReactNode;
  /** 최초 펼침 여부 (기본 true). 메인화면처럼 접힌 상태로 시작하려면 false. */
  defaultOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  // 다음 오픈 시 SiteList에 넘길 초기 상태 칩. 토글 오픈은 항상 전체('')로 되돌린다.
  const [initialStatus, setInitialStatus] = useState('');
  return (
    <SitePanelContext.Provider
      value={{
        isOpen,
        initialStatus,
        toggle: () => { setInitialStatus(''); setIsOpen((v) => !v); },
        open:   (status = '') => { setInitialStatus(status); setIsOpen(true); },
        close:  () => setIsOpen(false),
      }}
    >
      {children}
    </SitePanelContext.Provider>
  );
}

export function useSitePanel() {
  const ctx = useContext(SitePanelContext);
  if (!ctx) throw new Error('useSitePanel must be used inside SitePanelProvider');
  return ctx;
}
